import type { CreateCourseReview201ReviewerBasicInfo } from './createCourseReview201ReviewerBasicInfo';
import type { CreateCourseReview201ReviewerSocial } from './createCourseReview201ReviewerSocial';

/**
 * 리뷰 작성자 요약 정보
 */
export type CreateCourseReview201Reviewer = {
  /** 사용자 기본 정보 */
  basicInfo: CreateCourseReview201ReviewerBasicInfo;
  /** 소셜 관계 정보 */
  social?: CreateCourseReview201ReviewerSocial;
};
